// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2fUjC","inner":"Footer_inner__uUYT-","nextIcon":"Footer_nextIcon__1aUnc","innerLeft":"Footer_innerLeft__1_He7"};